import qs from 'qs';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import Footer from '~/components/Footer';
import Menu from '~/components/Menu';
import api from '~/services/api';
import { addIdModulo } from '~/store/modules/Grupos/actions';
import { addCompanyId } from '~/store/modules/User/actions';
import { Container } from '~/styles/pagesStyle';
import SearchModulo from './SearchModulo';

function ModuloGrupo() {
  const [form, setForm] = useState({});
  const [modulos, setModulos] = useState([{}]);
  const [loading, setLoading] = useState(true);
  const [isSelected, setIsSelected] = useState(false);
  const [companyData, setCompanyData] = useState([{}]);
  const dispatch = useDispatch();
  const getData = async () => {
    const params = {
      skip: 0,
      take: 1000,
    };
    await api
      .get(`/Pessoa/GetPessoaPaginado?${qs.stringify(params)}`)
      .then((response) => {
        const { data } = response.data;
        setLoading(false);
        setCompanyData(data);
      });
  };
  const getModules = async () => {
    const params = {
      skip: 0,
      take: 1000,
    };
    await api
      .get(`/Modulo?${qs.stringify(params)}`)
      .then((response) => {
        const { data } = response.data;
        setLoading(false);
        setModulos(data);
      })
      .catch(() => {
        toast.error('Erro ao buscar módulos, recarregue a página');
      });
  };
  useEffect(() => {
    getData();
    getModules();
  }, []);

  useEffect(() => {
    dispatch(addCompanyId(form.idPessoaEmpresa));
  }, [form.idPessoaEmpresa]);

  useEffect(() => {
    dispatch(addIdModulo(form.idModulo));
  }, [form.idModulo]);

  return (
    <Container>
      <Footer />
      <Menu />
      <SearchModulo
        loading={loading}
        modulos={modulos}
        isSelected={isSelected}
        setIsSelected={setIsSelected}
        setLoading={setLoading}
        companyData={companyData}
        form={form}
        setForm={setForm}
      />
    </Container>
  );
}

export default ModuloGrupo;
